import { Context, createContext, Provider } from 'react';
import { CupraApiClient } from '../client/CupraApiClient';

export const ApiClientContext: Context<CupraApiClient | undefined> = createContext<
  CupraApiClient | undefined
>(undefined);

export const ApiClientProvider: Provider<CupraApiClient | undefined> = ApiClientContext.Provider;
